module.exports = __webpack_public_path__ + "img/two.b5215eac.jpg";